import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  ja: {
    // Navigation
    home: 'ホーム',
    catalog: '講座',
    mypage: 'マイページ',
    help: 'ヘルプ',
    logout: 'ログアウト',
    profileGemsLabel: '石',
    profileLevelPrefix: 'Lv.',
    
    // Landing
    heroTitle: '次世代のオンライン学習体験',
    heroSubtitle: 'プロから学ぶ、実践的なスキルを身につける',
    startLearning: '学習を始める',
    discordLogin: 'Discordでログイン',
    features: '特徴',
    pricing: '料金プラン',
    
    // Plans
    freePlan: '無料プラン',
    monthlyPlan: '月額プラン',
    yearlyPlan: '年額プラン',
    perMonth: '/月',
    perYear: '/年',
    selectPlan: 'プランを選択',
    currentPlan: '現在のプラン',
    
    // Dashboard
    continueWatching: '続きから再生',
    recommended: 'おすすめ',
    newArrivals: '新着',
    popular: '人気',
    announcements: 'お知らせ',
    
    // Catalog
    filter: 'フィルター',
    sort: '並び替え',
    genre: 'ジャンル',
    tag: 'タグ',
    series: 'シリーズ',
    all: 'すべて',
    unwatched: '未視聴',
    newest: '新着順',
    oldest: '古い順',
    popularSort: '人気順',
    releaseDate: '公開日順',
    estimatedTime: '想定学習時間',
    episode: '第',
    
    // Series
    aboutCourse: '講座について',
    targetGoal: '到達目標',
    videoList: '動画一覧',
    progress: '進捗',
    locked: 'ロック中',
    
    // Video Player
    playbackSpeed: '再生速度',
    quality: '画質',
    subtitles: '字幕',
    subtitleOff: 'オフ',
    materials: '練習資料',
    download: 'ダウンロード',
    previous: '前へ',
    next: '次へ',
    autoPlay: '自動再生',
    continueFromLast: '前回の続きから再生',
    markAsWatched: '視聴済みにする',
    watchedDone: '視聴済み',
    
    // My Page
    profile: 'プロフィール',
    learningStatus: '学習状況',
    discordLearningTime: 'Discord学習時間',
    subscription: '課金/契約',
    settings: '設定',
    totalWatchTime: '合計視聴時間',
    completedVideos: '完了した動画',
    streak: '連続学習日数',
    badges: 'バッジ',
    videoWatchTime: '動画視聴時間',
    discordStudyTime: 'Discord学習時間',
    daily: '日',
    weekly: '週',
    monthly: '月',
    nextRenewal: '次回更新日',
    paymentFailed: '決済失敗',
    manageSubscription: 'サブスク管理',
    defaultSubtitleLang: 'デフォルト字幕言語',
    autoPlaySetting: '自動再生',
    notifications: '通知設定',
    emailNotifications: 'メール通知',
    discordNotifications: 'Discord通知',
    
    noResults: '結果が見つかりませんでした',
    
    // Help
    faq: 'よくある質問',
    contactUs: 'お問い合わせ',
    incidentInfo: '障害情報',
    
    // Footer
    terms: '利用規約',
    commerce: '特定商取引法',
    privacy: 'プライバシーポリシー',
    contact: 'お問い合わせ',
    
    // Genres
    programming: 'プログラミング',
    design: 'デザイン',
    business: 'ビジネス',
    language: '言語',
    other: 'その他',
    
    // Difficulty
    beginner: '初級',
    intermediate: '中級',
    advanced: '上級',
    
    // Status
    active: '有効',
    cancelled: 'キャンセル済み',
    past_due: '支払い遅延',
    blocked: 'ブロック中',
    
    // Misc
    minutes: '分',
    hours: '時間',
    videos: '本',
    days: '日',
    loading: '読み込み中...',
    save: '保存',
    cancel: 'キャンセル',
    submit: '送信',
  },
  en: {
    // Navigation
    home: 'Home',
    catalog: 'Courses',
    mypage: 'My Page',
    help: 'Help',
    logout: 'Logout',
    profileGemsLabel: 'stones',
    profileLevelPrefix: 'Lv.',
    
    // Landing
    heroTitle: 'Next-Gen Online Learning Experience',
    heroSubtitle: 'Learn from pros, acquire practical skills',
    startLearning: 'Start Learning',
    discordLogin: 'Login with Discord',
    features: 'Features',
    pricing: 'Pricing',
    
    // Plans
    freePlan: 'Free Plan',
    monthlyPlan: 'Monthly Plan',
    yearlyPlan: 'Yearly Plan',
    perMonth: '/mo',
    perYear: '/yr',
    selectPlan: 'Select Plan',
    currentPlan: 'Current Plan',
    
    // Dashboard
    continueWatching: 'Continue Watching',
    recommended: 'Recommended',
    newArrivals: 'New Arrivals',
    popular: 'Popular',
    announcements: 'Announcements',
    
    // Catalog
    filter: 'Filter',
    sort: 'Sort',
    genre: 'Genre',
    tag: 'Tag',
    series: 'Series',
    all: 'All',
    unwatched: 'Unwatched',
    newest: 'Newest',
    oldest: 'Oldest',
    popularSort: 'Popular',
    releaseDate: 'Release Date',
    estimatedTime: 'Estimated Time',
    episode: 'Ep.',
    
    // Series
    aboutCourse: 'About This Course',
    targetGoal: 'Target Goal',
    videoList: 'Video List',
    progress: 'Progress',
    locked: 'Locked',
    
    // Video Player
    playbackSpeed: 'Playback Speed',
    quality: 'Quality',
    subtitles: 'Subtitles',
    subtitleOff: 'Off',
    materials: 'Materials',
    download: 'Download',
    previous: 'Previous',
    next: 'Next',
    autoPlay: 'Auto Play',
    continueFromLast: 'Continue from last position',
    markAsWatched: 'Mark as watched',
    watchedDone: 'Watched',
    
    // My Page
    profile: 'Profile',
    learningStatus: 'Learning Status',
    discordLearningTime: 'Discord Learning Time',
    subscription: 'Subscription',
    settings: 'Settings',
    totalWatchTime: 'Total Watch Time',
    completedVideos: 'Completed Videos',
    streak: 'Learning Streak',
    badges: 'Badges',
    videoWatchTime: 'Video Watch Time',
    discordStudyTime: 'Discord Study Time',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    nextRenewal: 'Next Renewal',
    paymentFailed: 'Payment Failed',
    manageSubscription: 'Manage Subscription',
    defaultSubtitleLang: 'Default Subtitle Language',
    autoPlaySetting: 'Auto Play',
    notifications: 'Notifications',
    emailNotifications: 'Email Notifications',
    discordNotifications: 'Discord Notifications',
    
    noResults: 'No results found',
    
    // Help
    faq: 'FAQ',
    contactUs: 'Contact Us',
    incidentInfo: 'Incident Info',
    
    // Footer
    terms: 'Terms of Service',
    commerce: 'Commercial Law',
    privacy: 'Privacy Policy',
    contact: 'Contact',
    
    // Genres
    programming: 'Programming',
    design: 'Design',
    business: 'Business',
    language: 'Language',
    other: 'Other',
    
    // Difficulty
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    
    // Status
    active: 'Active',
    cancelled: 'Cancelled',
    past_due: 'Past Due',
    blocked: 'Blocked',
    
    // Misc
    minutes: 'min',
    hours: 'hrs',
    videos: 'videos',
    days: 'days',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    submit: 'Submit',
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('ja');

  useEffect(() => {
    const saved = localStorage.getItem('ui_language');
    if (saved) setLanguage(saved);
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('ui_language', lang);
  };

  const t = (key) => {
    return translations[language]?.[key] || translations['ja'][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    return { language: 'ja', changeLanguage: () => {}, t: (key) => key };
  }
  return context;
}